export const CONTACT_INFO = {
  email: 'stolmalformat@gmail.com',
  address: 'Polska',
  facebookUrl:
    'https://www.facebook.com/profile.php?id=61591456468091&rdid=m7idljVRwV3QuFJI&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1DUMzpNSbn%2F',
  contacts: [
    { name: 'Michal', phone: '+48 886 068 052' },
    { name: 'Grzegorz', phone: '+48 660 687 180' },
  ],
};
